// @ts-nocheck
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { FormFieldUploadedFileType } from "@store/Framework/Types/FormField";

const baseUrl = "/api/v1/custom/forms";

export interface SubmitContactUsTopicsFormApiParameter extends ApiParameter {
    attachments?: FormFieldUploadedFileType[];
    emailAddress: string;
    firstName: string;
    lastName: string;
    location: string;
    message: string;
    phoneNumber?: string;
    referenceProductId?: string;
    soldToNumber: string;
    shipToNumber: string;
    topic?: string;
}

export interface SubmitContactUsTopicsFormModel {
    success: boolean;
}

export async function submitContactUsTopicsForm(
    parameter: SubmitContactUsTopicsFormApiParameter,
): Promise<ServiceResult<SubmitContactUsTopicsFormModel>> {
    try {
        const result = await post<SubmitContactUsTopicsFormApiParameter, SubmitContactUsTopicsFormModel>(
            `${baseUrl}/loggedincontactus`,
            parameter,
        );

        return { successful: true, result };
    } catch (error) {
        return { successful: false, errorMessage: "" };
    }
}
